import React, {useEffect, useState} from 'react';
import {Sidebar, Segment, Dimmer, Loader, Message} from 'semantic-ui-react';
import SideBarMain from './SideBarMain';
import Header from '../components/Header';
import {RootState} from '../model';
import {connect} from 'react-redux';
import {useActions} from '../redux/actions';
import * as authActions from '../redux/actions/auth';
import * as appActions from '../redux/actions/app';
import {Account} from '../model/user';
import {App, Alert} from "../model";
import { deleteCookie } from '../utils/common';

import Loading from "../Loading";

interface Props {
    activeLink: string,
    children: any,
    app: App,
    user: Account
    alert: Alert
}

function Template(props: Props) {

    const authAction = useActions(authActions);
    const appAction = useActions(appActions);

    const listenerFromParent = (): void => {
        appAction.SidebarOpen(!(props.app.leftSidebarOpen))
    };

    const logout = async() => {
        await deleteCookie();
        await authAction.LogOut();
    };
    const handleMessage = () => {
        authAction.clearError();
    };


    const {leftSidebarOpen, loader} = props.app;

    return (
        <div className="cdp-udr">
            <Sidebar.Pushable className='mt-0' as={Segment}>
                <SideBarMain visible={leftSidebarOpen} user={props.user} />
                <Sidebar.Pusher>
                    <Segment basic>
                        <Header listenerFromParent={listenerFromParent} logout={logout} user={props.user}/>
                        <div className="container-fluid containerMain">

                            {loader && <Dimmer active inverted>
                                <Loading />
                            </Dimmer>
                            }
                            {(props.alert && props.alert.message && props.alert.message.length) &&
                                <Message
                                    onDismiss={handleMessage}
                                    error={true}
                                    header="Warning"
                                    className="global-error"
                                    content={props.alert.message}
                                />
                            }
                            {props.children}
                        </div>
                    </Segment>
                </Sidebar.Pusher>
            </Sidebar.Pushable>
        </div>
    );

}

function mapStateToProps(state: RootState) {
    return {
        user: state.auth.user,
        app: state.app,
        alert: state.alert
    };
}

export default connect(mapStateToProps)(Template);
